<template>
      <v-container :id="identifier" grid-list-lg>
        <v-layout wrap pl-5>
          <v-flex
            xs12 sm6 md6 lg4 xl3
            class='d-flex flex-wrap'
            data-aos='fade-up'
            :data-aos-delay='100+index'
            v-for='(employee,index) in employees'
            :key='index'
          >
            <v-card outlined class='employeeCard'>
              <v-card-text>
                <div class='overline pb-3'>{{ employee.department }}</div>
                <h1>{{employee.name}}</h1>
                <div class='subtitle-1 mb-3'>{{ employee.title }}</div>
                <v-icon left color='primary' v-if='employee.email'>mdi-email</v-icon>
                <a :href="`mailto:${employee.email}`" v-if='employee.email'>{{ employee.email }}</a>
              </v-card-text>  
              <v-img contain v-if="employee.picture" :src='employee.picture' max-height='256' max-width='128' />
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
</template>

<script>

export default {
  props: ['employees','identifier']
}
</script>

<style lang="stylus" scoped>
.employeeCard
  width 100%
  display grid
  grid-template-columns 65% 35%

.employeeCard .name
  word-break keep-all

a
  text-decoration none


</style>